import React from 'react'
import { Video, Block } from '@components'

const DatoCmsVideo = ({
  paddingTop,
  paddingBottom,
  backgroundColour,
  ...props
}) => {
  return (
    <Block
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      backgroundColour={backgroundColour}
      gutters
    >
      <Video {...props} />
    </Block>
  )
}

export default DatoCmsVideo
